<template>
  <ul
    class="grid flex-grow grid-cols-1 gap-x-4 gap-y-12 tracking-[.12em] sm:grid-cols-2 md:grid-cols-4"
  >
    <FooterMainMenuItem
      v-for="menuItem in menu"
      :key="menuItem.id"
      :menu-item="menuItem"
      :is-parent="true"
    >
      <ul
        v-if="menuItem.children && menuItem.children.length"
        class="grid grid-cols-1 gap-y-6"
      >
        <FooterMainMenuItem
          v-for="menuSubItem in menuItem.children"
          :key="menuSubItem.id"
          :menu-item="menuSubItem"
        />
      </ul>
    </FooterMainMenuItem>
  </ul>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import FooterMainMenuItem from '@/domains/menus/components/FooterMainMenuItem.vue';

interface Props {
  menu?: any[];
}

withDefaults(defineProps<Props>(), {
  menu: () => [],
});

const route = useRoute();
const activeItem = ref(null);

watch(
  () => route.fullPath,
  () => {
    activeItem.value = null;
  },
  { immediate: true },
);
</script>
